import { Link } from "react-router-dom";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import Marquee from "@/components/Marquee";
import Playground from "@/components/Playground";
import Hero from "@/sections/Hero";
import WhyProof from "@/sections/WhyProof";
import WhatItDoes from "@/sections/WhatItDoes";
import AnomalyShowcase from "@/sections/AnomalyShowcase";
import Pillars from "@/sections/Pillars";
import HowItWorks from "@/sections/HowItWorks";
import ApiOverview from "@/sections/ApiOverview";
import Audiences from "@/sections/Audiences";
import Roadmap from "@/sections/Roadmap";
import Pricing from "@/sections/Pricing";
import AccessSection from "@/sections/AccessSection";
import { Reveal, SectionHeading } from "@/components/motion";
import { ArrowUpRight } from "lucide-react";

const PlaygroundSection = () => (
  <section data-testid="playground-section" className="border-b border-border bg-muted/30">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-24 lg:py-32">
      <div className="flex flex-wrap items-end justify-between gap-8 mb-16">
        <SectionHeading index="07" eyebrow="Live Demo" title="Run the truth engine. Right now." />
        <Reveal delay={0.15}>
          <Link
            data-testid="playground-full-link"
            to="/playground"
            className="font-mono text-[11px] tracking-[0.2em] uppercase text-muted-foreground hover:text-foreground transition-colors duration-200 flex items-center gap-2"
          >
            Open full playground <ArrowUpRight className="w-4 h-4" />
          </Link>
        </Reveal>
      </div>
      <Reveal delay={0.1}>
        <Playground />
      </Reveal>
    </div>
  </section>
);

const Home = () => (
  <div data-testid="home-page" className="bg-background text-foreground">
    <Nav />
    <main>
      <Hero />
      <Marquee />
      <WhyProof />
      <WhatItDoes />
      <AnomalyShowcase />
      <Pillars />
      <HowItWorks />
      <ApiOverview />
      <PlaygroundSection />
      <Audiences />
      <Roadmap />
      <Pricing />
      <AccessSection />
    </main>
    <Footer />
  </div>
);

export default Home;
